import { type GroupFactory, Group as MantineGroup } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./group.module.scss";
import type { IProps } from "./group.types";

const Group = componentWrapper<GroupFactory, IProps>("Group", (props, ref) => {
    return <MantineGroup ref={ref} classNames={{ root: styles["container"] }} {...props} />;
});

export { Group };
